<script>
import HorizontalTopbar from './horizontal-topbar'
import HorizontalNav from '../shared/horizontal-nav'
import Footer from '../shared/footer'
//import menuItems from '../menu/user/index'

import { layoutComputed } from '@/state/helpers'

import api from '@/helpers/api'

/**
 * Horizontal-layout
 */
export default {
  components: {
    HorizontalTopbar,
    HorizontalNav,
    Footer
  },
  data () {
    return {
      menuItems: []
    }
  },
  computed: {
    ...layoutComputed
  },
  created: () => {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-sidebar')
    document.body.removeAttribute('data-layout-size')
  },
  methods: {
    toggleRightSidebar () {
      document.body.classList.toggle('right-bar-enabled')
    },
    hideRightSidebar () {
      document.body.classList.remove('right-bar-enabled')
    }
  },
  async mounted () {
    if (this.loader === true) {
      document.getElementById('preloader').style.display = 'block'
      document.getElementById('status').style.display = 'block'

      setTimeout(function () {
        document.getElementById('preloader').style.display = 'none'
        document.getElementById('status').style.display = 'none'
      }, 2500)
    } else {
      document.getElementById('preloader').style.display = 'none'
      document.getElementById('status').style.display = 'none'
    }

    let { items } = await api.items.fetchPage({
      page: 0,
      pageSize: -1,
      filters: [
        { is_webshop_item: { _eq: true } },
        { is_discontinued: { _eq: false } },
        { webshop_custom_form: { _is_null: false } }
      ],
      orderBy: [{ rating: 'desc' }, { short_description: 'asc' }]
    })

    var counter = 30
    let formItems = [
      ...items.map(p => {
        return {
          id: counter++,
          label: p.short_description,
          //icon: 'bx bx-shopping-bag',
          link: { name: 'forms', query: { id: p.id } }
        }
      })
    ]

    this.menuItems = [
      {
        id: 1,
        label: 'dashboard',
        icon: 'bx bx-home-circle',
        link: '/'
      },
      /* {
        id: 3,
        label: 'forms',
        icon: 'fab fa-wpforms',
        isUiElement: true,
        subItems: formItems
      },*/
      {
        id: 4,
        label: 'my orders',
        icon: 'bx bx-package',
        link: { name: 'sales.my-orders', force: true }
      },
      {
        id: 5,
        label: 'Statistics',
        icon: 'bx bx-line-chart',
        link: { name: 'stats.products' }
      }
    ]
  }
}
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <HorizontalTopbar :type="topbar" :width="layoutWidth" />
      <HorizontalNav :items="menuItems" />
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <slot />
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->
        <Footer />
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
  </div>
</template>
